import { cn, TokenIcon, TokenIconSymbol, Typography } from "@kyan/ui";

import { Divider } from "#/components/Divider/Divider";
import { RFQOrder } from "#/services/kyan/kyan.types";
import { useRfqResponses } from "#/store/rfq/rfqResponses";
import {
  formatInstrumentName,
  getInstrumentProperties,
  isOptionInstrument,
} from "#/utils/instrument.utils";
import { isBuy } from "#/utils/marketActionConverter";

interface RFQLegProps {
  order: RFQOrder;
  orderId: string;
}

export const RFQLeg: React.FC<RFQLegProps> = ({ order, orderId }) => {
  const { rfqResponses } = useRfqResponses();
  const isOption = isOptionInstrument(order.instrument_name);
  const { underlying } = getInstrumentProperties(order.instrument_name);

  const hasRfqResponse = rfqResponses.some(
    (response) => response.orderId === orderId,
  );

  return (
    <div className="relative flex items-center gap-2">
      <div className="bg-textSecondary/10 flex items-center rounded">
        <TokenIcon
          size="sm"
          className="text-textPrimary h-7 w-10 items-center"
          symbol={underlying.toLowerCase() as TokenIconSymbol}
        />
        <Divider className="h-7" isHorizontal={false} />
        <Typography
          xs
          grotesk
          className={cn(
            "px-2 leading-tight capitalize",
            isBuy(order.direction) ? "text-success" : "text-error",
          )}
        >
          {order.direction}
        </Typography>
      </div>

      <div className="flex flex-col">
        <Typography primary>
          {formatInstrumentName(order.instrument_name)}
        </Typography>
        <div className="flex items-center gap-1">
          <Typography xs grotesk variant="secondary">
            Size:
          </Typography>
          <Typography xs grotesk primary>
            {isOption ? `${order.contracts} contracts` : order.amount}
          </Typography>
        </div>
      </div>

      {hasRfqResponse && (
        <span className="absolute -top-1 -right-2 flex size-1.5">
          <span className="bg-success absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"></span>
          <span className="bg-success relative inline-flex size-1.5 rounded-full"></span>
        </span>
      )}
    </div>
  );
};
